

import { DynamicFieldData } from '@/shared/components/DynamicForm/models/DynamicFieldData'
import { AdditionalTab, DynamicFormDefinition, DynamicFormType } from '@/shared/components/DynamicForm/models/DynamicFormSection'

import { FormFieldDefaultValue, FormFieldSelectOptions, getDynamicFormFields } from '../../shared/lib/getDynamicFormFields'

const defaultOrderDetailFields: DynamicFieldData[] = [
  {
    fieldType: 'section',
    fieldName: 'orderDetailSectionTitle',
    label: 'Order Information',
    showDivider: false,
  },
  {
    fieldType: 'text',
    fieldName: 'orderNumber',
    label: 'Order Number',
    placeholder: 'Order Number',
    defaultValue: '',
    required: true,
    config: {
      required: 'Order number is required',
    },
  },
  {
    fieldType: 'text',
    fieldName: 'consignmentNumber',
    label: 'Consignment Number',
    placeholder: 'Consignment Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'date',
    fieldName: 'preferredDateOfOperation',
    label: 'Date',
    defaultValue: null,
    config: {},
  },
  {
    fieldName: 'attributes',
    fieldType: 'multiselect',
    label: 'Attributes',
    placeholder: 'Select Order Attributes',
    options: [],
    defaultValue: [],
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'tripNumber',
    label: 'Trip Number',
    placeholder: 'Trip Number',
    defaultValue: '',
    config: {},
  },

  {
    fieldType: 'text',
    fieldName: 'priority',
    label: 'Priority',
    placeholder: 'Order Priority',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'time',
    fieldName: 'maxOnboardTime',
    label: 'Max Onboard Time',
    defaultValue: '',
    views: ['hours', 'minutes'],
    format: 'HH:mm',
  },
  {
    fieldType: 'textarea',
    fieldName: 'description',
    label: 'Description',
    placeholder: 'Order Description',
    defaultValue: '',
    required: false,
    config: {
      maxLength: {
        value: 400,
        message: 'Description cannot exceed 400 characters',
      },
    },
  },
  {
    fieldType: 'textarea',
    fieldName: 'comments',
    label: 'Comments',
    placeholder: 'Delivery Instructions',
    defaultValue: '',
    required: false,
    config: {
      maxLength: {
        value: 400,
        message: 'Description cannot exceed 400 characters',
      },
    },
  },
  {
    fieldType: 'textarea',
    fieldName: 'comment',
    label: 'Comments',
    placeholder: 'Comments',
    defaultValue: '',
    config: {
      maxLength: {
        value: 450,
        message: 'Comments cannot exceed 450 characters',
      },
    },
  },
  {
    fieldType: 'number',
    fieldName: 'weight',
    label: 'Total Weight',
    placeholder: 'Weight',
    defaultValue: 0,
    config: {
      min: {
        value: 0,
        message: 'Weight cannot be less than 0',
      },
    },
    grid: {
      xs: 12,
      sm: 4,
    },
  },
  {
    fieldType: 'number',
    fieldName: 'volume',
    label: 'Total Volume',
    placeholder: 'Volume',
    defaultValue: 0,
    config: {
      min: {
        value: 0,
        message: 'Volume cannot be less than 0',
      },
    },
    grid: {
      xs: 12,
      sm: 4,
    },
  },
  {
    fieldType: 'number',
    fieldName: 'quantity',
    label: 'Total Quantity',
    placeholder: 'Quantity',
    defaultValue: 0,
    config: {
      min: {
        value: 0,
        message: 'Quantity cannot be less than 0',
      },
    },
    grid: {
      xs: 12,
      sm: 4,
    },
  },
]

const defaultPickupDetailFields: DynamicFieldData[] =  [
  {
    fieldType: 'section',
    fieldName: 'pickupSectionTitle',
    label: 'Pickup Info',
    showDivider: false,
  },
  {
    fieldType: 'text',
    fieldName: 'fromLocation.name',
    label: 'Name',
    placeholder: 'Pickup Location Name',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'fromLocation.externalId',
    label: 'Pickup Ref',
    placeholder: 'Pickup Reference Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'contactPickup',
    label: 'Contact',
    placeholder: 'Contact',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'emailPickup',
    label: 'Email',
    placeholder: 'Email',
    defaultValue: '',
    config: {
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Please enter a valid email address.',
      },
    },
  },
  {
    fieldType: 'text',
    fieldName: 'phonePickup',
    label: 'Phone No.',
    placeholder: 'Phone Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'smsPickup',
    label: 'SMS No.',
    placeholder: 'SMS Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'section',
    fieldName: 'pickupSchedulingSectionTitle',
    label: 'Pickup Scheduling Detail',
    showDivider: true,
  },
  {
    fieldType: 'time',
    fieldName: 'serviceTimePickup',
    label: 'Site Service Time',
    defaultValue: '',
    views: ['hours', 'minutes', 'seconds'],
    format: 'HH:mm:ss',
  },
  {
    fieldType: 'time',
    fieldName: 'twStartPickup',
    label: 'TW Start',
    defaultValue: '',
    views: ['hours', 'minutes'],
    format: 'HH:mm',
    config: {},
    grid: {
      xs: 12,
      sm: 10,
    },
  },
  {
    fieldType: 'checkbox',
    fieldName: 'twStartNextDayPickup',
    label: 'ND',
    addTopLabelMargin: true,
    defaultValue: false,
    config: {},
    grid: {
      xs: 12,
      sm: 2,
    },
  },
  {
    fieldType: 'time',
    fieldName: 'twFinishPickup',
    label: 'TW Finish',
    defaultValue: '',
    views: ['hours', 'minutes'],
    format: 'HH:mm',
    config: {},
    grid: {
      xs: 12,
      sm: 10,
    },
  },
  {
    fieldType: 'checkbox',
    fieldName: 'twFinishNextDayPickup',
    label: 'ND',
    addTopLabelMargin: true,
    defaultValue: false,
    config: {},
    grid: {
      xs: 12,
      sm: 2,
    },
  },
  {
    fieldType: 'section',
    fieldName: 'pickupAddressSectionTitle',
    label: 'Address',
    showDivider: true,
  },
  {
    fieldType: 'address',
    fieldName: 'addressPickup',
    label: 'Address',
    defaultValue: {
      street: '',
      suburb: '',
      state: '',
      postcode: '',
      country: 'Australia',
    },
  },
]

const defaultDropoffDetailFields: DynamicFieldData[] =  [
  {
    fieldType: 'section',
    fieldName: 'dropoffSectionTitle',
    label: 'Dropoff Info',
    showDivider: false,
  },
  {
    fieldType: 'text',
    fieldName: 'toLocation.name',
    label: 'Name',
    placeholder: 'Dropoff Location Name',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'toLocation.externalId',
    label: 'Dropoff Ref',
    placeholder: 'Dropoff Reference Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'contactDelivery',
    label: 'Contact',
    placeholder: 'Contact',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'emailDelivery',
    label: 'Email',
    placeholder: 'Email',
    defaultValue: '',
    config: {
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Please enter a valid email address.',
      },
    },
  },
  {
    fieldType: 'text',
    fieldName: 'phoneDelivery',
    label: 'Phone No.',
    placeholder: 'Phone Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'text',
    fieldName: 'smsDelivery',
    label: 'SMS No.',
    placeholder: 'SMS Number',
    defaultValue: '',
    config: {},
  },
  {
    fieldType: 'section',
    fieldName: 'dropoffSchedulingSectionTitle',
    label: 'Dropoff Scheduling Detail',
    showDivider: true,
  },
  {
    fieldType: 'time',
    fieldName: 'serviceTimeDelivery',
    label: 'Site Service Time',
    defaultValue: '',
    views: ['hours', 'minutes', 'seconds'],
    format: 'HH:mm:ss',
  },
  {
    fieldType: 'time',
    fieldName: 'twStartDelivery',
    label: 'TW Start',
    defaultValue: '',
    views: ['hours', 'minutes'],
    format: 'HH:mm',
    config: {},
    grid: {
      xs: 12,
      sm: 10,
    },
  },
  {
    fieldType: 'checkbox',
    fieldName: 'twStartNextDayDelivery',
    label: 'ND',
    addTopLabelMargin: true,
    defaultValue: false,
    config: {},
    grid: {
      xs: 12,
      sm: 2,
    },
  },
  {
    fieldType: 'time',
    fieldName: 'twFinishDelivery',
    label: 'TW Finish',
    defaultValue: '',
    views: ['hours', 'minutes'],
    format: 'HH:mm',
    config: {},
    grid: {
      xs: 12,
      sm: 10,
    },
  },
  {
    fieldType: 'checkbox',
    fieldName: 'twFinishNextDayDelivery',
    label: 'ND',
    addTopLabelMargin: true,
    defaultValue: false,
    config: {},
    grid: {
      xs: 12,
      sm: 2,
    },
  },
  {
    fieldType: 'section',
    fieldName: 'deliveryAddressSectionTitle',
    label: 'Address',
    showDivider: true,
  },
  {
    fieldType: 'address',
    fieldName: 'addressDelivery',
    label: 'Address',
    defaultValue: {
      street: '',
      suburb: '',
      state: '',
      postcode: '',
      country: 'Australia',
    },
  },
]

type GetFormDefinitionForDepotModelArgs = {
  defaultValues?: FormFieldDefaultValue
  selectOptions?: FormFieldSelectOptions
  formType?: DynamicFormType
  additionalTabs?: AdditionalTab[]
}

export const getFormDefinitionForCourierModel = ({
  defaultValues, 
  selectOptions,
  additionalTabs,
  formType = 'stepper',
}: GetFormDefinitionForDepotModelArgs): DynamicFormDefinition => {
  const orderDetailFields = getDynamicFormFields({
    fields: defaultOrderDetailFields,
    defaultValues,
    selectOptions,
  })
  const pickupDetailFields = getDynamicFormFields({
    fields: defaultPickupDetailFields,
    defaultValues,
    selectOptions,
  })
  const dropoffDetailFields = getDynamicFormFields({
    fields: defaultDropoffDetailFields,
    defaultValues,
    selectOptions,
  })

  const formDefinition: DynamicFormDefinition = {
    formType: formType,
    additionalTabs,
    sections: [
      {
        label: 'Order Detail',
        fields: orderDetailFields,
      },
      {
        label: 'Pickup Detail',
        fields: pickupDetailFields,
      },
      {
        label: 'Dropoff Detail',
        fields: dropoffDetailFields,
      },
    ],
  }

  return formDefinition
}